/* eslint-disable react/destructuring-assignment */
import React, { useContext, useState } from "react";
import { string, number, bool, func } from "prop-types";
import GridTable from "pages/_components/GridTable/GridTable";
import { TransactionContext } from "pages/_components/TransactionCard/TransactionContext";
import FormattedAmount from "pages/_components/FormattedAmount";
import CustomData from "pages/_components/CustomData/CustomData";
import ProductList from "pages/_components/product/List";
import TitleColumns from "./TitleColumns";
import EndorseItem from "./ItemRow";
import { isDesktop } from "react-device-detect";

const AcceptReturnSummaryBody = ({ isDesktop, ...props }) => {
    const { transaction = {} } = useContext(TransactionContext);
    const { data = {} } = transaction;
    const {
        numeroEcheq = props.numeroEcheq,
        montoTotal = props.montoTotal,
        curency = props.curency,
        idEcheq = props.idEcheq,
        caracter = props.caracter,
        document = props.document,
        fechaPago = props.fechaPago,
        nombreSolicitante = props.nombreSolicitante,
        cuilSolicitante = props.cuilSolicitante,
        endosos = props.endosos,
    } = data;

    return (
        <>
            <GridTable className="form-summary">
                <GridTable.Container>
                    <GridTable.Data>
                        <CustomData titleText="echecks.id.label" titleTextType="I18N" valueText={idEcheq} />
                    </GridTable.Data>
                    <GridTable.Data>
                        <CustomData
                            titleText="echecks.payedRange.label"
                            titleTextType="I18N"
                            valueText={fechaPago}
                            valueTextType="DATE"
                        />
                    </GridTable.Data>
                    <GridTable.Data>
                        <CustomData titleText=" echecks.currency" titleTextType="I18N" valueText={curency} />
                    </GridTable.Data>
                    <GridTable.Data>
                        <CustomData titleText="echecks.number.label" titleTextType="I18N" valueText={numeroEcheq} />
                    </GridTable.Data>
                    <GridTable.Data>
                        <CustomData
                            titleText="echecks.monto.total"
                            titleTextType="I18N"
                            valueText={
                                <FormattedAmount className="data-label" currency={curency} quantity={montoTotal} />
                            }
                        />
                    </GridTable.Data>
                    <GridTable.Data>
                        <CustomData titleText="echecks.character" titleTextType="I18N" valueText={caracter} />
                    </GridTable.Data>
                    <GridTable.Data>
                        <CustomData
                            titleText="echeq.accept.return.solicitor.name"
                            titleTextType="I18N"
                            valueText={nombreSolicitante}
                        />
                    </GridTable.Data>
                    <GridTable.Data>
                        <CustomData
                            titleText="echeq.accept.return.solicitor.document"
                            titleTextType="I18N"
                            valueText={cuilSolicitante}
                        />
                    </GridTable.Data>
                </GridTable.Container>
            </GridTable>

            {endosos?.length > 0 && (
                <GridTable className="form-summary mt-8 pt-0 pb-0">
                    <ProductList
                        fetchingWithPreviousData
                        fetching={false}
                        items={endosos || []}
                        noDataText="global.no.results"
                        noFiltersDataText="global.no.results"
                        renderItem={(item) => (
                            <GridTable.Container
                                key={item.fechaPago}
                                renderAs="div"
                                // className={!isDesktop && "box box-shadow"}
                            >
                                <EndorseItem item={item} isDesktop={isDesktop} />
                            </GridTable.Container>
                        )}>
                        {(listItem) => (
                            <GridTable className="detail-discounts-table tablelist">
                                <GridTable.Header>
                                    <GridTable.Container>
                                        <TitleColumns />{" "}
                                    </GridTable.Container>
                                </GridTable.Header>
                                <GridTable.Body>{listItem}</GridTable.Body>
                            </GridTable>
                        )}
                    </ProductList>
                </GridTable>
            )}
        </>
    );
};

AcceptReturnSummaryBody.propTypes = {
    isDesktop: bool,
};

AcceptReturnSummaryBody.defaultProps = {
    isDesktop: true,
};

export default AcceptReturnSummaryBody;
